export default "__VITE_ASSET__BhbV7V0V__"